export const en = {
    error_required: 'Fill in this field',
    error_must_be_a_number: 'Must be a number',
};
